import { useState, useCallback } from 'react';
import { matchingService } from '@/services/matching.service';
import type { PbevVehicle, FipeVehicle } from '@/types';

export const useSuggestions = () => {
  const [suggestions, setSuggestions] = useState<PbevVehicle[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchSuggestions = useCallback(async (fipeVehicle: FipeVehicle) => {
    try {
      setLoading(true);
      setError(null);
      const data = await matchingService.getSuggestions(
        fipeVehicle.model_id,
        fipeVehicle.marca,
        fipeVehicle.modelo
      );
      setSuggestions(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch suggestions');
    } finally {
      setLoading(false);
    }
  }, []);

  const clearSuggestions = useCallback(() => {
    setSuggestions([]);
  }, []);

  return { suggestions, loading, error, fetchSuggestions, clearSuggestions };
};
